import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import { Subscription } from "rxjs/Subscription";
import { appConfig } from "../../core-config";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { QRCode } from "../../forked/qr_code";
import { AnnounceDialogComponent, AnnounceDialogModalData, ConfirmationModalDialogComponent } from "../../modalDialogs";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { CheckoutService, LastOrderInfo } from "../../services/checkout.service";
import { CoreCOMService } from "../../services/com.service";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { UserHelperService } from "../../services/userHelper.service";
import { WebVoucherService } from "../../services/web_voucher.service";
import { WebShopService } from "../../services/webShop.service";
import { AnounceModalResult, orderTypes } from "../../shared/contentTypes";
import { CheckoutPaymentModel, ResponseCode_Done } from "../../shared/models/checkout.model";
import Utils from "../../shared/utils";
import { TrackingManager } from "../../services/tracking/tracking-manager";
import { TrackingEvent } from "../../services/tracking/tracking-event.enum";
import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/internal/operators/filter";

@Component({
  selector: 'inHouseOrderresult',
  templateUrl: './inHouseOrderresult.component.html',
  styleUrls: ['./inHouseOrderresult.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InHouseOrderresultComponent implements OnInit, AfterViewInit, OnDestroy {

  public checkoutpaymentmodel: CheckoutPaymentModel;
  public ResponseCode_Done = ResponseCode_Done;

  public lastOrderInfo: LastOrderInfo;
  private _isMandatory_Payment: boolean = false;
  private _tableNo: string = "";
  private _orderConfirm_Subtext: string = "";
  public _posTableNumberQrCodeSvg: string;

  private _localeChangeSubscription: Subscription;
  private _isWebshopFullyLoadedSubscription: Subscription;
  private _userLoginSubscription: Subscription;
  private _inHouseUiDataChangedSubscription: Subscription;
  private _inHouseTableClosedSubscription: Subscription;


  // Emits `true` when the QR code is visible; used to trigger brightness setup responsively.
  public qrCodeVisible$ = new BehaviorSubject(false);

  //inHouseData
  public get isGroupOrder(): boolean {
    return !Utils.IsNullOrEmpty(this._inHouseOrderService.GroupName);
  }
  private openItemValue: number = 0;
  private openBillValue: number = 0;
  public get hasOpenItems(): boolean {
    return this.openItemValue > 0;
  }
  public get openItems(): string {
    const me = this;
    return _.escape(me._coreLanguageService.value("phInHouseOrderResult_OpenItems"))
      .replace("{items}", `<span class="emphasized">${me.openItemValue.toString()}</span>`)
      .replace("{total}", `<span class="emphasized">${me._webShopService.formatCurrency(me.openBillValue)}</span>`);
  }

  public returnURL: string = "";

  constructor(private _webShopService: WebShopService
    , private _inHouseOrderService: InHouseOrderService
    , private _userHelperService: UserHelperService
    , private _checkoutService: CheckoutService
    , private _internationalisationService: InternationalisationService
    , private _activatedRoute: ActivatedRoute
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreCOMService: CoreCOMService
    , private _coreLanguageService: CoreLanguageService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _sanitized: DomSanitizer
    , private _router: Router
    , private _trackingManager: TrackingManager) {
  }

  ngOnInit() {
    const me = this;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["CheckoutPaymentModel"]) {
      me.checkoutpaymentmodel = routeTargetData["CheckoutPaymentModel"];

      // verhintern des Tisch geschlossen Dialogs solange man sich im Result befindet
      me._inHouseOrderService.suppressNextTableClosedWarning = true;

      me._checkoutService.getLastOrderInfo().then(lastOrderInfo => {
        me.lastOrderInfo = lastOrderInfo;
        me.returnURL = me.checkoutpaymentmodel.done === ResponseCode_Done.Authorised ? lastOrderInfo.returnURLSuccess : lastOrderInfo.returnURLFail;

        if (!Utils.IsNullOrEmpty(me.lastOrderInfo.qrCode)) {
          me._tableDataForMandatoryPayment();
        }
        // ermitteln ob InHouse eingeloegt ist und noch offene Artikel hat
        me._inHouseOrderService.TryGetBackToStoredTableOrGroup().then((response) => {
          if (response) {
            if (response.success) {
              me.openItemValue = me._inHouseOrderService.UiData.open_amount;
              me.openBillValue = me._inHouseOrderService.UiData.open_price;

              me._inHouseUiDataChangedSubscription = me._inHouseOrderService.ObserveUiDataChanged.subscribe((uiData) => {
                me.openItemValue = uiData.open_amount;
                me.openBillValue = uiData.open_price;
                me.PushChanges();
              });

              me._inHouseTableClosedSubscription = me._inHouseOrderService.ObserveOnTableClosedChanged.subscribe((_) => {
                me.openItemValue = 0;
                me.openBillValue = 0;
                me.PushChanges();
              });

              me.PushChanges();
            } // else has no old place
          }
        });

        me._localeChangeSubscription = me._internationalisationService.localeChanged.subscribe(() => {
          me.PushChanges();
        });
        me._isWebshopFullyLoadedSubscription = me._webShopService.getFullyLoadedObservable.subscribe(() => {
          if (me.checkoutpaymentmodel.done === ResponseCode_Done.Authorised) {
            me._webShopService.resetWebshopService();
          }
          me.PushChanges();
        });
        me._userLoginSubscription = me._userHelperService.RegisterObserver.subscribe((registered) => {
          if (registered && me.lastOrderInfo.deliveryAddressViewModel && me.lastOrderInfo.deliveryAddressViewModel.id === "") {
            me._webShopService.saveNewCustomerFurtherAddress(me.lastOrderInfo.deliveryAddressViewModel);
          }
        });

        this.trackPurchase();
      }).catch(e => {
        me._coreLogService.error("OrderResultComponent.ngOnInit", "_checkoutService.getLastOrderInfo", e);
      });

    } else {
      // No Last Checkoutmodel, Redirect to StartPage and Replace Orderresult in History to make it skipable
      if (me._inHouseOrderService.UserToken) {
        me._inHouseOrderService.openInHauseLandingPage();
      } else {
        me._router.navigateByUrl("/", { replaceUrl: true, skipLocationChange: true });
      }
      return;
    }
    if (me._userHelperService.IsRegistered) {
      console.log("Result page--> INIT Method");
    }
    me.PushChanges();
  }

  async ngAfterViewInit(): Promise<void> { }

  private trackPurchase(): void {
    if (!this.lastOrderInfo || !this.lastOrderInfo.orderedItems || !this.lastOrderInfo.orderedItems.length) return;

    this._trackingManager.trackPurchase(
      this.lastOrderInfo.id,
      this.lastOrderInfo.orderedItems,
      this._webShopService.currencySymbol,
      this._webShopService.getBasketSumTotal(),
      this._webShopService.finalDeliveryFee,
    );
  }


  async ngOnDestroy(): Promise<void> {
    const me = this;

    // erlaube erneut die Warnung über das Verlassen desch tischess
    me._inHouseOrderService.suppressNextTableClosedWarning = false;

    if (me._localeChangeSubscription)
      me._localeChangeSubscription.unsubscribe();
    if (me._isWebshopFullyLoadedSubscription)
      me._isWebshopFullyLoadedSubscription.unsubscribe();
    if (me._userLoginSubscription)
      me._userLoginSubscription.unsubscribe();
    if (me._inHouseUiDataChangedSubscription)
      me._inHouseUiDataChangedSubscription.unsubscribe();
    if (me._inHouseTableClosedSubscription)
      me._inHouseTableClosedSubscription.unsubscribe();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("OrderResultComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** Table data required to display the text for the mandatory payment.
   * ist async
   */
  private _tableDataForMandatoryPayment(): void {
    const me = this;
    me._inHouseOrderService.GetTableQRCodeData(me.lastOrderInfo.qrCode).then((tableData) => {
      if (me._isMandatory_Payment != tableData.mandatory_Payment) {
        me._isMandatory_Payment = tableData.mandatory_Payment;
      }
      me._tableNo = tableData.tableNr;
      if (me._isMandatory_Payment) {
        me._getOrderConfirmSubtext();
        // action_json enthält Daten, bei Zahlung am POS
        if (me.checkoutpaymentmodel.action_json) {
          var action = JSON.parse(me.checkoutpaymentmodel.action_json);
          if (action && action.type === "pay_at_waiter") {
            const tablenumberqrcode = "?tAbvRGnR=" + action.table_no;
            me._posTableNumberQrCodeSvg = tablenumberqrcode.trim();
            // NoCOO wird generiert für eine mögliche Zahling, diese wurde aber nicht ausgeführt
            // Zahlung muss am POS erfolgen
            me.checkoutpaymentmodel.nocoo = "";
            me.qrCodeVisible$.next(true);
          }
        } // else es ist keine Zahlung am POS
      }
      me.PushChanges();
    });
  }

  /** Subtext for order confirmation  */
  private _getOrderConfirmSubtext() {
    const me = this;
    me._webShopService.getWebshopSettingsDataModel().then((settings) => {
      const location = me.lastOrderInfo.location;
      if (location) {
        const ih_ordertype = settings.ordertypes.find((ordertype) => ordertype.id == orderTypes.inHouse);
        if (ih_ordertype) {
          const location_settings = ih_ordertype.location_settings.find((loc_settings) => loc_settings.location === location)
          if (location_settings) {
            me._orderConfirm_Subtext = location_settings.order_confirmation_extra_text;
            me.PushChanges();
          } // else es ist keine abweichende standort einstellung
        } else {
          me._coreLogService.error("InHouseOrderresultComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel no ih_ordertype");
        }
      } else {
        me._coreLogService.error("InHouseOrderresultComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel no location");
      }
    }).catch((error) => {
      me._coreLogService.error("InHouseOrderresultComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel catch", error);
    });
  }

  public get isMandatoryPayment() {
    const me = this;
    return me._isMandatory_Payment;
  }

  public get orderConfirmInfo(): string {
    const me = this;
    return me._coreLanguageService.value("phInHouseOrderResult_Mandatory_Payment_Info").replace("{table_no}", `<span class="emphasized">${me._tableNo}</span>`);
  }

  public get odreConfirmSubText(): string {
    const me = this;
    return me._orderConfirm_Subtext;
  }

  /** prüfung ob eine QrCode SVG vorhanden ist für die Ausgabe */
  public get hasPosTableNumberQrCodeSvg(): boolean {
    return this._posTableNumberQrCodeSvg != null;
  }

  /** QrCode für das Scannen des Tisches am POS */
  public get posTableNumberQrCodeSvg(): SafeHtml {
    return this._posTableNumberQrCodeSvg;
  }

  // todo veralgemeinern zwischen orderresult und InHouseOrderresult
  public get bonuspointsHtmlRows(): string[] {
    const me = this;
    let htmlRows: string[] = [];
    const bonuspoints = WebVoucherService.parseNewBonusPointsFromBonusPointString(me.checkoutpaymentmodel.BonuspointsVersion, me.checkoutpaymentmodel.BonuspointsForParsing);
    if (bonuspoints) {
      htmlRows = bonuspoints.map((bonus) => {
        const pointstext = this._coreLanguageService.value((bonus.points === 1) ? "phOrderResult_Point" : "phOrderResult_Points");
        return _.escape(this._coreLanguageService.value("phOrderResult_CollectedPointsForBonus_BASE"))
          .replace("{points}", `<span class="emphasized">${bonus.points} ${pointstext}</span>`)
          .replace("{bonusaction}", `<span class="emphasized">${bonus.label_de}</span>`);
      });
    }
    return htmlRows;
  }

  /** prüfung ob der NoCOO Button angezeigt werden sollte */
  public get showToNoCOOBtn(): boolean {
    const nocooData = this.checkoutpaymentmodel.NoCOOData;
    return nocooData && !Utils.IsNullOrEmpty(nocooData.code);
  }

  public gotoNoCOO(): string {
    const me = this;
    const bottomSheetRef = me._bottomSheetHelperService.open(ConfirmationModalDialogComponent, {
      data: {
        title: "phConfirmDialog_NoCOO_Title",
        description: "phConfirmDialog_NoCOO_Text",
        buttonText: "phConfirmDialog_NoCOO_Button",
      }
    });
    bottomSheetRef.afterDismissed().subscribe((result: boolean) => {
      if (result) {
        window.open(me.checkoutpaymentmodel.NoCOOUrlWithPin, "_system");
      }
    });
    return;
  }

  public get showInHauseLandingPageBtn(): boolean {
    return this.hasOpenItems || this._inHouseOrderService.PlaceNo > 0;
  }

  /** Springt auf die InHouse Landingpage */
  public openInHauseLandingPage() {
    const me = this;
    me._inHouseOrderService.openInHauseLandingPage();
  }

  public get showReturnToHomeBtn(): boolean {
    return this.returnURL.length === 0;
  }

  /** Springt auf HomeScreen, bei Zahlung am POS kommt vorab ein Hinweis */
  public gotoHome() {
    const me = this;
    if (me.hasPosTableNumberQrCodeSvg) {
      const data: AnnounceDialogModalData = {
        title: "phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Title",
        content: "phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Content",
        firstBtnLabel: "phInHouseOrderResult_ToTheHomescreen",
        secondBtnLabel: "phInHouseOrderResult_AnnounceDialog_PayAtWaiter_StayBtn",
      }
      const bottomSheetRef = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
        data: data
      });
      bottomSheetRef.afterDismissed().subscribe((result: AnounceModalResult) => {
        if (result === AnounceModalResult.FirstButton) {
          me._router.navigate(["/"]);
        } // else keine Navigation
      });
    } else {
      me._router.navigate(["/"]);
    }
  }

  public get showReturnToURLBtn(): boolean {
    return this.returnURL.length > 0;
  }

  /** Springt zur InHouse Payment Seite */
  public returnToPayment() {
    const me = this;
    if (me._inHouseOrderService.TableData && me._inHouseOrderService.TableData.mandatory_Payment) {
      // bei zahlungszwang wird das normale Checkout durchlaufen
      me._router.navigate(["/webshop"]);
    } else {
      me._router.navigate(["/inHausePayment"]);
    }
  }
}
